<div class="flex min-h-[60vh] relative">
  <div class="flex gap-4 flex-grow">
    @if (affair) {
      <p-card
        class="flex-grow info-card"
        styleClass="bg-zinc-900 border border-zinc-700 shadow-lg"
      >
        <ng-template pTemplate="header">
          <div
            class="flex items-center justify-between px-4 py-3 bg-zinc-800 rounded-t-lg"
          >
            <div class="flex items-center">
              <i class="pi pi-info-circle text-blue-400 mr-2 text-xl"></i>
              <h2 class="text-lg font-medium">Informations générales</h2>
            </div>
            <p-button
              icon="pi pi-external-link"
              styleClass="p-button-rounded p-button-text"
              pTooltip="Ouvrir dans Éros"
              tooltipPosition="left"
              (click)="navigateToEros()"
            ></p-button>
          </div>
        </ng-template>

        <!-- Identification -->
        <div class="section-title">
          <i class="pi pi-id-card text-blue-300 mr-2"></i>
          <span>Identification</span>
        </div>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">
              <i class="pi pi-id-card mr-2"></i>Référence MYLINK
            </span>
            <span class="info-value">{{ affair?.mlRef ?? 'NC' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">
              <i class="pi pi-tag mr-2"></i>Type de marché
            </span>
            <span class="info-value">{{
              affair?.marketType?.name ?? 'NC'
            }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">
              <i class="pi pi-building mr-2"></i>Accompagnateur
            </span>
            <span class="info-value">{{ affair?.erpSource ?? 'NC' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">
              <i class="pi pi-link mr-2"></i>Lié à Constéo
            </span>
            <span class="info-value">{{
              affair?.consteoId ? 'OUI' : 'NON'
            }}</span>
          </div>
        </div>

        <!-- Localisation -->
        <div class="section-title">
          <i class="pi pi-map-marker text-green-300 mr-2"></i>
          <span>Localisation</span>
        </div>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">
              <i class="pi pi-home mr-2"></i>Adresse
            </span>
            <span class="info-value">{{
              affair?.workSiteComposedAddress ?? 'NC'
            }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">
              <i class="pi pi-hashtag mr-2"></i>Code postal
            </span>
            <span class="info-value">{{
              affair?.workSitePostalCode ?? 'NC'
            }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">
              <i class="pi pi-map mr-2"></i>Ville
            </span>
            <span class="info-value">{{
              affair?.workSiteLocality ?? 'NC'
            }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">
              <i class="pi pi-envelope mr-2"></i>Email
            </span>
            <span class="info-value">{{
              affair?.finalCustomerEmail ?? 'NC'
            }}</span>
          </div>
        </div>
      </p-card>

      <!-- Informations sociétés -->
      <div class="flex gap-4 flex-col w-[32%] min-h-full">
        @for (societyInfo of affair.srcErp; track $index) {
          @if (societyInfo.value) {
            <p-card
              class="w-full society-card"
              styleClass="bg-zinc-900 border border-zinc-700 shadow-lg transform transition-all duration-300"
            >
              <ng-template pTemplate="header">
                <div
                  class="flex items-center justify-center p-3 bg-zinc-800 rounded-t-lg"
                >
                  <p class="text-center text-lg font-medium">
                    Informations
                    <i
                      class="tll tll-24 fa-logo-{{
                        societyInfo.value.erpSource
                      }} text-{{ societyInfo.value.erpSource }} ml-2"
                    ></i>
                  </p>
                </div>
              </ng-template>
              <div class="society-info-grid">
                <div class="info-item">
                  <span class="info-label">
                    <i class="pi pi-pencil mr-2"></i>Note
                  </span>
                  <span class="info-value truncate">
                    {{ societyInfo.value.administrativeInternalNote ?? 'NC' }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">
                    <i class="pi pi-user mr-2"></i>Assistant(e)
                  </span>
                  <span class="info-value">
                    {{
                      societyInfo.value.userAssistant?.firstname +
                        ' ' +
                        societyInfo.value.userAssistant?.lastname || 'NC'
                    }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="info-label">
                    <i class="pi pi-user-plus mr-2"></i>Technicien(ne)
                  </span>
                  <span class="info-value">
                    {{
                      societyInfo.value.userTechnician?.firstname +
                        ' ' +
                        societyInfo.value.userTechnician?.lastname || 'NC'
                    }}
                  </span>
                </div>
              </div>
            </p-card>
          }
        }
      </div>
    }
  </div>
</div>
